export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SHOW_LOGOUT_WARNING = 'SHOW_LOGOUT_WARNING';
export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_SET_CONNECTED = 'AUTH_SET_CONNECTED';
